@if (isLoaded()) {
  <div class="modal-header">
    <h4 class="modal-title">{{getHeader()}}</h4>
    @if (isLeverantor()) {
      <small><i>{{ 'LEVERANTOR_LABEL_SENASTE_UPPDATERINGEN_FRAN_LIME' | translate }}:
      {{kontakt.kontaktReceiveDateTime | date : 'HH:mm dd MMM yyyy'}}</i></small>
    }
  </div>
}
@if (!hasEditRole()) {
  <div class="alert alert-warning"><span translate>LEVERANTOR_LABEL_HAR_EJ_REDIGERA_ROLL</span>
</div>
}
@if (isLoaded()) {
  <div class="modal-body">
    <div [formGroup]="formLeverantor">
      <rask-tabs aid="tabs" [useRoute]="false" layout="parent">
        <rask-tab label="Kontakt" [icon]="getMomsnummerStatusIcon()" [iconColorType]="getMomsnummerStatusIconColor()">
          <!---------- tab 1 ---------->
          <div class="row">
            @if (isLeverantor()) {
              <fieldset class="form-group col-6">
                <label translate class="col-form-label">LEVERANTOR_LABEL_LIMEID</label>
                <div><i>{{kontakt.kontaktLimeId}}</i></div>
              </fieldset>
            }
            <fieldset class="form-group col-6">
              <label translate class="col-form-label">LEVERANTOR_LABEL_KONTAKTTYP</label>
              @if (canEditTypAvKontakt()) {
                <fieldset>
                  <div class="form-check form-check-inline">
                    <input formControlName="typAvKontakt" type="radio" id="typavkontaktjuridiskperson"
                      class="form-check-input" [value]="'Juridisk person'"
                      (change)="onTypAvKontaktChange($event)">
                      <label translate class="form-check-label"
                      for="typavkontaktjuridiskperson">Juridisk person</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input formControlName="typAvKontakt" type="radio" id="typavkontaktprivatperson"
                        class="form-check-input" [value]="'Privatperson'"
                        (change)="onTypAvKontaktChange($event)">
                        <label translate class="form-check-label"
                        for="typavkontaktprivatperson">Privatperson</label>
                      </div>
                    </fieldset>
                  }
                  @if (!canEditTypAvKontakt()) {
                    <fieldset>
                      <div><i>{{kontakt.typAvKontakt}}</i></div>
                    </fieldset>
                  }
                </fieldset>
              </div>
              <div class="row">
                @if (kontakt.typAvKontakt === 'Juridisk person') {
                  <fieldset class="form-group col-6">
                    <label translate class="col-form-label" translate>LEVERANTOR_LABEL_NAMN</label>
                    <input type="text" class="form-control" formControlName="kontaktNamn" placeholder="" />
                    <rask-validation-message [for]="kontakt.kontaktNamn"
                    [rule]="validationContext.current.kontaktNamn"></rask-validation-message>
                  </fieldset>
                }
                @if (kontakt.typAvKontakt === 'Privatperson') {
                  <fieldset class="form-group col-3">
                    <label translate class="col-form-label" translate>LEVERANTOR_LABEL_FORNAMN</label>
                    <input type="text" class="form-control" formControlName="kontaktpersonFornamn"
                      placeholder="" maxlength="50" (change)="onNamnChange()" />
                      @if (kontakt.kontaktSkyddadIdentitet) {
                        <i translate>LEVERANTOR_LABEL_SKYDDADIDENTITET</i>
                      }
                      <rask-validation-message [for]="kontakt.kontaktpersonFornamn"
                      [rule]="validationContext.current.kontaktpersonFornamn"></rask-validation-message>
                    </fieldset>
                  }
                  @if (kontakt.typAvKontakt === 'Privatperson') {
                    <fieldset class="form-group col-3">
                      <label translate class="col-form-label" translate>LEVERANTOR_LABEL_EFTERNAMN</label>
                      <input type="text" class="form-control" formControlName="kontaktpersonEfternamn"
                        placeholder="" maxlength="50" (change)="onNamnChange()" />
                        <rask-validation-message [for]="kontakt.kontaktpersonEfternamn"
                        [rule]="validationContext.current.kontaktpersonEfternamn"></rask-validation-message>
                      </fieldset>
                    }
                    <fieldset class="form-group col-6">
                      <label translate class="col-form-label" translate>LEVERANTOR_LABEL_ORGNR</label>
                      <input type="text" class="form-control"
                        placeholder="{{ kontakt.typAvKontakt === 'Juridisk person' ? 'nnnnnn-nnnn' : 'YYYYMMDD-XXXX' }}"
                        formControlName="kontaktOrgnummer"
                        [maxlength]="kontakt.typAvKontakt === 'Juridisk person' ? 11 : 13"
                        (change)="onChangeOrgnummer()" [raskDisabledControl]="orgnummerDisabled()" />
                        <rask-validation-message [for]="kontakt.kontaktOrgnummer"
                        [rule]="validationContext.current.kontaktOrgnr"></rask-validation-message>
                        <rask-validation-message [for]="kontakt.kontaktOrgnummer"
                        [rule]="validationContext.current.kontaktOrgnrFormat"></rask-validation-message>
                      </fieldset>
                    </div>
                    @if (kontakt.typAvKontakt === 'Juridisk person') {
                      <div class="row">
                        <fieldset class="form-group col-6">
                          <label translate class="col-form-label">{{ 'LEVERANTOR_LABEL_KONTAKTPERSON' | translate}}
                          {{ 'LEVERANTOR_LABEL_FORNAMN' | translate}}</label>
                          <input type="text" class="form-control" formControlName="kontaktpersonFornamn"
                            placeholder="" maxlength="50" />
                            <rask-validation-message [for]="kontakt.kontaktpersonFornamn"
                            [rule]="validationContext.current.kontaktpersonFornamn"></rask-validation-message>
                            @if (kontakt.kontaktSkyddadIdentitet) {
                              <i translate>LEVERANTOR_LABEL_SKYDDADIDENTITET</i>
                            }
                          </fieldset>
                          <fieldset class="form-group col-6">
                            <label translate
                            class="col-form-label">{{ 'LEVERANTOR_LABEL_EFTERNAMN' | translate}}</label>
                            <input type="text" class="form-control" formControlName="kontaktpersonEfternamn"
                              placeholder="" maxlength="50" />
                              <rask-validation-message [for]="kontakt.kontaktpersonEfternamn"
                              [rule]="validationContext.current.kontaktpersonEfternamn"></rask-validation-message>
                            </fieldset>
                          </div>
                        }
                        <div class="row">
                          <fieldset class="form-group col-3">
                            <label translate class="col-form-label" translate>LEVERANTOR_LABEL_TELEFON</label>
                            <input type="text" class="form-control" formControlName="kontaktTelefon" placeholder="" />
                            <rask-validation-message [for]="kontakt.kontaktTelefon"
                            [rule]="validationContext.current.kontaktTelefon"></rask-validation-message>
                          </fieldset>
                          <fieldset class="form-group col-3">
                            <label translate class="col-form-label" translate>LEVERANTOR_LABEL_MOBIL</label>
                            <input type="text" class="form-control" formControlName="kontaktKontaktMobiltelefon"
                              placeholder="" />
                              <rask-validation-message [for]="kontakt.kontaktKontaktMobiltelefon"
                              [rule]="validationContext.current.kontaktKontaktMobiltelefon"></rask-validation-message>
                            </fieldset>
                            <fieldset class="form-group col-6">
                              <label translate class="col-form-label" translate>LEVERANTOR_LABEL_EPOST</label>
                              <input type="text" class="form-control" formControlName="kontaktKontaktEpost" placeholder="" />
                              <rask-validation-message [for]="kontakt.kontaktKontaktEpost"
                                [rule]="validationContext.current.kontaktEpostFormat">
                              </rask-validation-message>
                            </fieldset>
                          </div>
                          <div class="row">
                            <fieldset class="form-group col-6">
                              <label for="postadressLabel" class="col-form-label"
                              translate>LEVERANTOR_LABEL_ADRESS</label>
                              <input type="text" class="form-control" formControlName="kontaktAdress" placeholder="" />
                              <rask-validation-message [for]="kontakt.kontaktAdress"
                              [rule]="validationContext.current.kontaktAdress"></rask-validation-message>
                            </fieldset>
                            <fieldset class="form-group col-6">
                              <label for="postadressLabel" class="col-form-label"
                              translate>LEVERANTOR_LABEL_ADRESS2</label>
                              <input type="text" class="form-control" formControlName="kontaktAdress2" placeholder="" />
                              <rask-validation-message [for]="kontakt.kontaktAdress2"
                              [rule]="validationContext.current.kontaktAdress2"></rask-validation-message>
                            </fieldset>
                          </div>
                          <div class="row">
                            <fieldset class="form-group col-3">
                              <label for="postnrLabel" class="col-form-label" translate>LEVERANTOR_LABEL_POSTNR</label>
                              <input type="text" class="form-control" formControlName="kontaktPostnummer" placeholder="" />
                              <rask-validation-message [for]="kontakt.kontaktPostnummer"
                                [rule]="validationContext.current.kontaktPostnr">
                              </rask-validation-message>
                            </fieldset>
                            <fieldset class="form-group col-3">
                              <label for="postortLabel" class="col-form-label" translate>LEVERANTOR_LABEL_POSTORT</label>
                              <input type="text" class="form-control" formControlName="kontaktPostort" placeholder="" />
                              <rask-validation-message [for]="kontakt.kontaktPostort"
                                [rule]="validationContext.current.kontaktOrt">
                                </rask-validation-message>
                            <rask-validation-message [for]="kontakt.kontaktPostort"
                                [rule]="validationContext.current.kontaktOrtReq">
                              </rask-validation-message>
                            </fieldset>
                            <fieldset class="form-group col-6">
                              <label for="landLabel" class="col-form-label" translate>LEVERANTOR_LABEL_LAND</label>
                              <input type="text" class="form-control" formControlName="kontaktLand" placeholder=""
                                maxlength="30" />
                                <rask-validation-message [for]="kontakt.kontaktLand"
                                [rule]="validationContext.current.kontaktLand"></rask-validation-message>
                              </fieldset>
                            </div>
                            <div class="row">
                              <div class="col-4 px-0">
                                <rask-input
                                  class="w-100"
                                  label="{{ 'LEVERANTOR_LABEL_MOMS_REGNR' | translate }}"
                                  formControlName="momsregistreringsnummer"
                                  [maxlengthhide]="30"
                                  [raskDisabledControl]="kontakt.momsnummerEjAktuellt"
                                  (change)="momsnummerChanged()"
                                  [raskRule]="validationContext.current.kontaktMomsregStatusOgiltig"
                                  ruleContainerId="kontaktMomsregStatus">
                                  <ng-container appendContent>
                                    <rask-input-validation-icon
                                      [isValid]="isMomsValid()"
                                      text="Kontrollera numrets giltighet"
                                      (click)="validateVies()">
                                    </rask-input-validation-icon>
                                  </ng-container>
                                </rask-input>
                                <rask-input class="d-none"
                                  [raskRule]="validationContext.current.kontaktMomsregStatusFelEjValiderad"
                                ruleContainerId="kontaktMomsregStatus"></rask-input>
                                <rask-input class="d-none" [raskRule]="validationContext.current.kontaktMomsregFormat"
                                ruleContainerId="kontaktMomsregStatus"></rask-input>
                                <rask-input class="d-none"
                                  [raskRule]="validationContext.current.kontaktMomsregStatusPleaseCheck"
                                ruleContainerId="kontaktMomsregStatus"></rask-input>
                                <div class="vies-info">
                                  @if (kontakt.momsnummerValideringstid) {
                                    <div class="vies-date">Senaste hämtningen från
                                    VIES: {{ kontakt.momsnummerValideringstid | date:'short'}}</div>
                                  }
                                  @if (kontakt.momsnummerValideringsstatus && kontakt.momsnummerValideringsstatus !== momsnummerValideringsstatus.giltig) {
                                    <div
                                      class="vies-status">Senaste sökningen: {{ kontakt.momsnummerKontrollerat }} - {{
                                    getViesStatusText() }}</div>
                                  }
                                </div>
                              </div>
                              <div class="col-4 px-0">
                                <rask-textmultiline label="{{ 'LEVERANTOR_LABEL_MOMS_KOD' | translate }}"
                                [value]="getMomskodText(kontakt.momskod)"></rask-textmultiline>
                              </div>
                              <div class="col-4 px-0">
                                @if (isMomsnummerOgiltig()) {
                                  <div>
                                    <rask-checkbox text="Momsnummer ej aktuellt" formControlName="momsnummerEjAktuellt"
                                    (change)="momsnummerEjAkutelltChanged($event)"></rask-checkbox>
                                    <div class="momsnr-ej-aktuell">
                                      @if (kontakt.momsnummerEjAktuellt) {
                                        <div class="momsnr-ej-aktuell-info">
                                          Angivet av {{kontakt.momsnummerEjAktuelltAnsvarig.fornamn}}
                                          {{kontakt.momsnummerEjAktuelltAnsvarig.efternamn}}
                                        {{kontakt.momsnummerEjAktuelltTidpunkt | date:'short'}}</div>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                            <div class="row">
                              <div class="col">
                                <rask-validation-message-container id="kontaktMomsregStatus">
                                </rask-validation-message-container>
                              </div>
                            </div>
                          </rask-tab>
                          <rask-tab label="Betalningsinformation">
                            <!---------- tab 2 ---------->
                            @if(isLeverantor()){
                              <rask-betalningsinformation
                                [kontakt]="kontakt"
                                (betalningsinformationChange)="handleBetalningsinformationChange($event)">
                              </rask-betalningsinformation>
                            }
                            @else {
                            <div class="row">
                              <fieldset class="form-group col-4 px-0">
                                <rask-selector
                                  id="inputBetalningsmetod"
                                  label="{{ 'LEVERANTOR_LABEL_BETALNINGSMETOD' | translate }}"
                                  formControlName="betalningsmetod"
                                  [viewFormatter]="betalningViewFormatter"
                                  [formatter]="betalningValueFormatter"
                                  [rule]="validationContext.current.betalningsmetod"
                                  [values]="betalningsmetoder">
                                </rask-selector>
                              </fieldset>
                              @if (kontakt.betalningsmetod === 'Konto') {
                                <fieldset class="form-group col-4 px-0">
                                  <rask-input
                                    class="w-100"
                                    label="Clearing (exakt 4 siffror)"
                                    [placeholder]="1234"
                                    formControlName="clearingnummer"
                                    [maxlengthhide]="4"
                                    infoText="Clearingnummer är fyrställigt (vid fem siffror stryks sista siffran). Kontonummer skrivs utan punkter, mellanslag eller streck. Exempel: clearing 8452 kontonummer 123456781"
                                    (change)="triggerValidation()">
                                  </rask-input>
                                </fieldset>
                              }
                              @if (kontakt.betalningsmetod === 'Konto') {
                                <fieldset class="form-group col-4 px-0">
                                  <rask-input
                                    class="w-100"
                                    label="{{ 'LEVERANTOR_LABEL_BANKKONTO' | translate }}"
                                    formControlName="bankkonto"
                                    [maxlengthhide]="20"
                                    (change)="triggerValidation()">
                                  </rask-input>
                                </fieldset>
                              }
                              @if (kontakt.betalningsmetod === 'Bankgiro') {
                                <fieldset class="form-group col-4 px-0">
                                  <rask-input
                                    class="w-100"
                                    label="{{ 'LEVERANTOR_LABEL_BANKGIRO' | translate }}"
                                    formControlName="bankgiro"
                                    [maxlengthhide]="30"
                                    [rule]="validationContext.current.bankgironummer">
                                  </rask-input>
                                </fieldset>
                              }
                              @if (kontakt.betalningsmetod === 'Postgiro') {
                                <fieldset class="form-group col-4 px-0">
                                  <rask-input
                                    class="w-100"
                                    label="{{ 'LEVERANTOR_LABEL_PLUSGIRO' | translate }}"
                                    formControlName="postgiro"
                                    [maxlengthhide]="30"
                                    [rule]="validationContext.current.plusgironummer">
                                  </rask-input>
                                </fieldset>
                              }
                            </div>
                            <div class="row">
                              <fieldset class="form-group col-4 px-0">
                                <rask-input
                                  class="w-100"
                                  label="{{ 'LEVERANTOR_LABEL_GLN' | translate }}"
                                  formControlName="gln"
                                  [maxlengthhide]="40">
                                </rask-input>
                              </fieldset>
                              <fieldset class="form-group col-4 px-0">
                                <rask-input
                                  class="w-100"
                                  label="{{ 'LEVERANTOR_LABEL_IBAN' | translate }}"
                                  formControlName="iban"
                                  [maxlengthhide]="40">
                                </rask-input>
                              </fieldset>
                              <fieldset class="form-group col-4 px-0">
                                <rask-input
                                  class="w-100"
                                  label="{{ 'LEVERANTOR_LABEL_BIC_SWIFT' | translate }}"
                                  formControlName="bicSwift"
                                  [maxlengthhide]="40">
                                </rask-input>
                              </fieldset>
                            </div>
                          }
                        </rask-tab>
                        <rask-tab label="Leverantörsvård">
                          <!---------- tab 3 ---------->
                          <div class="row">
                            <fieldset class="form-group col-6">
                              <label for="inputUtbo" class="col-form-label" translate>LEVERANTOR_LABEL_UTBO_ABO</label>
                              <select id="inputUtbo" name="inputUtbo" class="form-control" formControlName="utbo">
                                @for (item of utbos; track item) {
                                  <option [value]="item.id">{{item.namn}}</option>
                                }
                              </select>
                            </fieldset>
                            <fieldset class="form-group col-6">
                              <label for="inputKlassning" class="col-form-label"
                              translate>LEVERANTOR_LABEL_KLASSNING</label>
                              <select id="inputKlassning" name="inputKlassning" class="form-control"
                                formControlName="klassning">
                                @for (item of klassningar; track item) {
                                  <option [value]="item.id">{{item.namn}}</option>
                                }
                              </select>
                            </fieldset>
                          </div>
                          <div class="row">
                            <fieldset class="form-group col-6">
                              <label class="col-form-label" translate>LEVERANTOR_LABEL_UTSKICK</label>
                              <div class="form-check">
                                <input type="checkbox" class="form-check-input" id="villHaAlmanackan"
                                  formControlName="villHaAlmanackan" placeholder="">
                                  <label class="form-check-label" for="villHaAlmanackan"
                                  translate>LEVERANTOR_LABEL_VILLHAALMANACKAN</label>
                                </div>
                                <div class="form-check">
                                  <input type="checkbox" class="form-check-input" id="avstarForum"
                                    formControlName="avstarForum" placeholder="">
                                    <label class="form-check-label" for="avstarForum"
                                    translate>LEVERANTOR_LABEL_AVSTARFORUM</label>
                                  </div>
                                </fieldset>
                                <fieldset class="form-group col-6">
                                  <label for="inputGruppering" class="col-form-label"
                                  translate>LEVERANTOR_LABEL_GRUPPERING</label>
                                  <select id="inputGruppering" name="inputGruppering" class="form-control"
                                    formControlName="gruppering">
                                    @for (item of grupperingar; track item) {
                                      <option [value]="item.id">{{item.namn}}</option>
                                    }
                                  </select>
                                </fieldset>
                              </div>
                              <div class="row">
                                <fieldset class="form-group col-6">
                                  <label class="col-form-label" translate>LEVERANTOR_LABEL_ANSV_VIRKESKOPARE</label>
                                  <rask-redigera-ansvarig-virkeskopare [disabled]="!hasEditRole()"
                                    [virkeskopare]="kontakt.ansvarigVirkeskopare"
                                    (virkeskopareChange)="virkeskoparechanged($event)">
                                  </rask-redigera-ansvarig-virkeskopare>
                                </fieldset>
                                <fieldset class="form-group col-6">
                                  <label class="col-form-label" translate>LEVERANTOR_LABEL_INTRESSENTER</label>
                                  <rask-redigera-intressent [disabled]="!hasEditRole()" [leverantorid]="kontakt.id"
                                    (removed)="intressentremoved($event)" (added)="intressentadded($event)">
                                  </rask-redigera-intressent>
                                </fieldset>
                              </div>
                            </rask-tab>
                            <rask-tab label="Administrativ information">
                              <!---------- tab 4 ---------->
                              <div class="row">
                                @if (kontakt.typAvKontakt === 'Juridisk person') {
                                  <fieldset class="form-group col-4 px-0">
                                    <rask-selector
                                      id="inputPosition3Intnr"
                                      label="SPECIFIKT INTERNNUMMER"
                                      [raskDisabledControl]="!hasKopleda()"
                                      formControlName="position3Intnr"
                                      [viewFormatter]="position3IntnrViewFormatter"
                                      [formatter]="position3IntnrValueFormatter"
                                      [values]="position3IntnrOptions"
                                      infoText="Här ändras position tre i internnumret. Fältet kan endast editeras av Köpledare">
                                    </rask-selector>
                                  </fieldset>
                                }
                                <fieldset class="form-group col-6 px-0">
                                  <rask-selector label="Anskaffningsform" formControlName="anskaffningsform"
                                    [allowAnyValue]="true"
                                    [reverseLookup]="false"
                                    [values]="anskaffningsformer">
                                  </rask-selector>
                                </fieldset>
                              </div>
                              @if (canHaveHuvudKodInternnummerViol3()) {
                                <div class="row">
                                  <fieldset class="form-group col-12 px-0">
                                    <rask-selector label="Huvudkod-Internnummer" formControlName="huvudkodInternnummerViol3"
                                      [allowAnyValue]="true"
                                      [reverseLookup]="false"
                                      [viewFormatter]="formatter"
                                      [formatter]="formatter"
                                      [search]="searchForHuvudKod">
                                    </rask-selector>
                                  </fieldset>
                                </div>
                              }
                              <div class="row">
                                <fieldset class="form-group col-6">
                                  <rask-simple-selector
                                    class="fill ps-0"
                                    label="EXTERN ORGANISATION"
                                    aid="integrationExternOrganisation"
                                    id="integrationExternOrganisation"
                                    formControlName="integrationExternOrganisation"
                                    [values]="externaOrganisationer"
                                    [clearable]="true">
                                  </rask-simple-selector>
                                </fieldset>
                              </div>
                              <div class="row">
                                @if (integrationExternOrganisationSelected()) {
                                  <fieldset class="form-group col-6">
                                    <rask-textmultiline class="fill ps-0" aid="integrationAnsvarigVirkeskopare"
                                      label="Ansvarig virkesköpare" [tightLabel]="true">
                                      <rask-redigera-ansvarig-virkeskopare [disabled]="!hasEditRole()"
                                        [virkeskopare]="kontakt.integrationAnsvarigVirkeskopare"
                                        (virkeskopareChange)="integrationAnsvarigVirkeskoparechanged($event)">
                                      </rask-redigera-ansvarig-virkeskopare>
                                    </rask-textmultiline>
                                  </fieldset>
                                }
                                @if (integrationExternOrganisationSelected()) {
                                  <fieldset class="form-group col-6">
                                    <rask-simple-selector
                                      class="fill"
                                      label="Prislista"
                                      aid="integrationPrislistaId"
                                      id="integrationPrislistaId"
                                      formControlName="integrationPrislistaId"
                                      [values]="prislistor"
                                      bindLabel="benamning"
                                      bindValue="id"
                                      [clearable]="true">
                                    </rask-simple-selector>
                                  </fieldset>
                                }
                              </div>
                              <div class="row">
                                @if (integrationExternOrganisationSelected()) {
                                  <fieldset class="form-group col-6">
                                    <rask-simple-selector
                                      class="fill ps-0"
                                      label="PEFC"
                                      aid="integrationPEFCCertifikatId"
                                      id="integrationPEFCCertifikatId"
                                      formControlName="integrationPEFCCertifikatId"
                                      [values]="certifikatPEFC"
                                      bindLabel="namn"
                                      bindValue="id"
                                      [clearable]="true">
                                    </rask-simple-selector>
                                  </fieldset>
                                }
                                @if (integrationExternOrganisationSelected()) {
                                  <fieldset class="form-group col-6">
                                    <rask-simple-selector
                                      class="fill"
                                      label="FSC"
                                      aid="integrationFSCCertifikatId"
                                      id="integrationFSCCertifikatId"
                                      formControlName="integrationFSCCertifikatId"
                                      [values]="certifikatFSC"
                                      bindLabel="namn"
                                      bindValue="id"
                                      [clearable]="true">
                                    </rask-simple-selector>
                                  </fieldset>
                                }
                              </div>
                              <div class="row">
                                <rask-externa-organisationer
                                  [externOrganisationer]="kontakt.externOrganisationer"
                                  (externOrganisationerChange)="handleExternOrganisationerChange($event)">
                                </rask-externa-organisationer>
                              </div>
                            </rask-tab>
                          </rask-tabs>
                        </div>
                      </div>
                    }

                    @if (isLoaded() && hasEditRole()) {
                      <div class="modal-footer">
                        <div class="row w-100">
                          <div class="col-12 mb-3">
                            @if (hasValidationErrors()) {
                              <div>
                                <rask-message-panel [items]="aggregatedErrorsAndWarnings">
                                </rask-message-panel>
                              </div>
                            }
                          </div>
                          <div class="col-12 text-center">
                            @if (!isNew()) {
                              <rask-save-button (click)="save(isLeverantor())" [disabled]="isDirty() === false">
                              </rask-save-button>
                              @if (isAnbudsleverantor()) {
                                <rask-button color="secondary" (click)="createLime()"
                                  [disabled]="isDirty()">
                                  {{'LEVERANTOR_LABEL_SKAPA_I_LIME' | translate}}
                                </rask-button>
                              }
                              <rask-button color="secondary" (click)="tryClose(true)">Avbryt</rask-button>
                            } @else {
                              <rask-button color="secondary" [disabled]="!isDirty()" (click)="save(true)">
                              {{'LEVERANTOR_LABEL_SKAPA_ANBUDSLEVERANTOR' | translate}}</rask-button>
                              <rask-button color="secondary" [disabled]="!isDirty()" (click)="saveNewAndCreateLime()">
                              {{'LEVERANTOR_LABEL_SKAPA_LEVERANTOR' | translate}}</rask-button>
                              <rask-button color="secondary" (click)="tryClose(true)">Avbryt</rask-button>
                            }
                          </div>
                        </div>
                      </div>
                    }